//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DataBlockDictionaryItemClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetDataBlockDictionaryItemQueryParameters = {
  dictionaryId?: number | undefined ;
  all?: boolean | undefined ;
  searchQuery?: string | null | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type PatchDataBlockDictionaryItemQueryParameters = {
  id: number ;
}

export type RemoveDataBlockDictionaryItemQueryParameters = {
  id: number ;
}

export function getUrl(dictionaryId?: number | undefined, all?: boolean | undefined, searchQuery?: string | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/data-blocks/dictionary-items?";
if (dictionaryId === null)
    throw new Error("The parameter 'dictionaryId' cannot be null.");
else if (dictionaryId !== undefined)
    url_ += "dictionaryId=" + encodeURIComponent("" + dictionaryId) + "&";
if (all === null)
    throw new Error("The parameter 'all' cannot be null.");
else if (all !== undefined)
    url_ += "all=" + encodeURIComponent("" + all) + "&";
if (searchQuery !== undefined && searchQuery !== null)
    url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockDictionaryItemDto, unknown, Types.PageableListDtoOfDataBlockDictionaryItemDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfDataBlockDictionaryItemDto, unknown, Types.PageableListDtoOfDataBlockDictionaryItemDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetDataBlockDictionaryItemQueryParameters): QueryKey;
export function getQueryKey(dictionaryId?: number | undefined, all?: boolean | undefined, searchQuery?: string | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { dictionaryId, all, searchQuery, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetDataBlockDictionaryItemQueryParameters;

    return trimArrayEnd([
        'DataBlockDictionaryItemClient',
        'get',
        dictionaryId as any,
        all as any,
        searchQuery as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockDictionaryItemClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as boolean | undefined,       context.queryKey[4] as string | null | undefined,       context.queryKey[5] as number | undefined,       context.queryKey[6] as number | undefined,       context.queryKey[7] as string | null | undefined,       context.queryKey[8] as Types.SortDirection | undefined,       context.queryKey[9] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.PageableListDtoOfDataBlockDictionaryItemDto, TError = unknown>(dto: GetDataBlockDictionaryItemQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockDictionaryItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.PageableListDtoOfDataBlockDictionaryItemDto, TError = unknown>(dictionaryId?: number | undefined, all?: boolean | undefined, searchQuery?: string | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockDictionaryItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.PageableListDtoOfDataBlockDictionaryItemDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfDataBlockDictionaryItemDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let dictionaryId: any = undefined;
  let all: any = undefined;
  let searchQuery: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ dictionaryId, all, searchQuery, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetDataBlockDictionaryItemQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [dictionaryId, all, searchQuery, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfDataBlockDictionaryItemDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(dictionaryId, all, searchQuery, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockDictionaryItemDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfDataBlockDictionaryItemDto | undefined) => Types.PageableListDtoOfDataBlockDictionaryItemDto, dictionaryId?: number | undefined, all?: boolean | undefined, searchQuery?: string | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getQueryKey(dictionaryId, all, searchQuery, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfDataBlockDictionaryItemDto | undefined) => Types.PageableListDtoOfDataBlockDictionaryItemDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks/dictionary-items";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'DataBlockDictionaryItemClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockDictionaryItemDto, unknown, Types.CreateDataBlockDictionaryItemDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockDictionaryItemDto, unknown, Types.CreateDataBlockDictionaryItemDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateDataBlockDictionaryItemDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/dictionary-items/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockDictionaryItemClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DataBlockDictionaryItemDto, unknown, Types.PatchDataBlockDictionaryItemDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockDictionaryItemDto, unknown, Types.PatchDataBlockDictionaryItemDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchDataBlockDictionaryItemDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchDataBlockDictionaryItemQueryParameters & {
  dto: Types.PatchDataBlockDictionaryItemDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockDictionaryItemDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchDataBlockDictionaryItemQueryParameters}): UseMutationResult<Types.DataBlockDictionaryItemDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/dictionary-items/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockDictionaryItemClient',
      'remove',
      id as any,
    ]);
}

export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveDataBlockDictionaryItemQueryParameters

export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveDataBlockDictionaryItemQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}